// extracted by mini-css-extract-plugin
export default {"loaderContainer":"LoaderContainer_loaderContainer__Y4RmO","loader":"LoaderContainer_loader__PC1kX"};